// extracted by mini-css-extract-plugin
export default {"catalog_item":"style_catalog_item__zcTqw","catalog_item_name":"style_catalog_item_name__Nkb4K","catalog_item_img":"style_catalog_item_img__hkebV"};